import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Navbar from "../../components/Navbar";
import ImageUploader from "../../components/ImageUploader";
import { API_recursos } from "../../config/apiConfig";
import "./css/NuevoEmpleo.css";
import { API_BASE_URL } from "../../config/apiConfig";

const NuevoRecursoSocial = () => {
  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [link, setLink] = useState("");
  const [categoria, setCategoria] = useState("");
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [finPermanente, setFinPermanente] = useState(false);
  const [destacado, setDestacado] = useState(false);
  const [ambito, setAmbito] = useState("");
  const [ambitoType, setAmbitoType] = useState(""); // "Isla Cristina" | "Otro"
  const [imagePath, setImagePath] = useState(null);
  const [mostrarModal, setMostrarModal] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams(); // para edición

  // Cargar datos cuando editamos
  useEffect(() => {
    const cargarDatos = async () => {
      if (!id) return;
      try {
        const res = await fetch(API_recursos);
        const data = await res.json();
        const recurso = data.find((r) => r._id === id);
        if (!recurso) return;

        setTitulo(recurso.title || "");
        setDescripcion(recurso.description || "");
        setLink(recurso.link || "");
        setCategoria(recurso.category || "");
        setFechaInicio(recurso.featuredStart?.slice(0, 10) || "");

        const fin = recurso.featuredEnd;
        const esPermanente = !fin || new Date(fin).getFullYear() === 1970;
        if (esPermanente) {
          setFinPermanente(true);
          setFechaFin("");
        } else {
          setFinPermanente(false);
          setFechaFin(fin.slice(0, 10));
        }

        setAmbito(recurso.location || "");
        if (recurso.location?.toLowerCase() === "isla cristina") {
          setAmbitoType("Isla Cristina");
        } else {
          setAmbitoType("Otro");
        }

        setDestacado(recurso.isFeatured || false);
        setImagePath(recurso.imagePath || null);
      } catch (error) {
        console.error("Error al cargar recurso:", error);
      }
    };

    cargarDatos();
  }, [id]);

  // Guardar datos
  const handleCrearRecurso = async () => {
    if (!titulo || !descripcion || !categoria || !ambito) {
      toast.error("Por favor, rellena todos los campos obligatorios (*)");
      return;
    }

    const body = {
      title: titulo,
      description: descripcion,
      isFeatured: destacado,
      category: categoria,
      imagePath: imagePath,
      availableUntil: null,
      link: link || null,
      featuredStart: fechaInicio ? new Date(fechaInicio).toISOString() : null,
      location: ambito,
      featuredEnd: finPermanente ? null : fechaFin ? new Date(fechaFin).toISOString() : null,
    };

    try {
      const url = id ? `${API_recursos}/${id}` : API_recursos;
      const method = id ? "PUT" : "POST";

      const response = await fetch(url, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      if (!response.ok) throw new Error("Error al guardar el recurso");

      toast.success(`Recurso ${id ? "actualizado" : "creado"} correctamente`, {
        autoClose: 2000,
      });
      setTimeout(() => navigate("/admin/social"), 2000);
    } catch (error) {
      console.error("Error al enviar el recurso:", error);
      toast.error("Hubo un error al guardar el recurso");
    }
  };

  // Handlers auxiliares
  const handleCancelar = () => setMostrarModal(true);
  const handleSalir = () => navigate("/admin/social");

  return (
    <>
      <Navbar />

      <main className="main creacion-ofertas">
        <section className="cabecera between">
          <h1 className="titulo-user align-center">{id ? "EDITAR RECURSO SOCIAL" : "NUEVO RECURSO SOCIAL"}</h1>

          <div className="noticias-destacadas align-center">
            <input type="checkbox" id="destacado" checked={destacado} onChange={(e) => setDestacado(e.target.checked)} />
            <label htmlFor="destacado"> Colocar en Destacados</label>
          </div>
        </section>

        <section className="formulario-alta between">
          <div className="comple-recurso column gap-30 w-450">
            {/* Titulo */}
            <div className="campo column">
              <label className="verde mayusculas">Título del recurso *</label>
              <input type="text" value={titulo} onChange={(e) => setTitulo(e.target.value)} required />
            </div>

            {/* Link */}
            <div className="campo column">
              <label className="verde mayusculas">Link del recurso</label>
              <input type="text" value={link} onChange={(e) => setLink(e.target.value)} />
            </div>

            {/* Imagen */}
            <ImageUploader
              imageUrl={imagePath}
              onImageChange={setImagePath}
              folder="recursos-sociales"
              label="Subir imagen"
              accept="image/*"
            />
          </div>

          <div className="info-recurso categorias-sociales column gap-30">
            <div className="between">
              {/* Categoría */}
              <div className="campo column w-325">
                <label className="mayusculas verde">Categoría del recurso *</label>
                {["Subvenciones", "Prestaciones", "Vivienda"].map((tipo) => (
                  <div className="checkbox" key={tipo}>
                    <input
                      type="radio"
                      name="categoria"
                      value={tipo}
                      checked={categoria === tipo}
                      onChange={(e) => setCategoria(e.target.value)}
                      required
                    />
                    <label className="ml-10">{tipo.charAt(0).toUpperCase() + tipo.slice(1)}</label>
                  </div>
                ))}
              </div>

              {/* Fechas */}
              <div className="campo column w-200">
                <label className="verde mayusculas">Fechas</label>
                <div className="align-center gap-5">
                  <p className="verde">Inicio:</p>
                  <input type="date" value={fechaInicio} onChange={(e) => setFechaInicio(e.target.value)} />
                </div>
                <div className="align-center gap-5">
                  <p className="verde fin">Fin:</p>
                  {finPermanente ? (
                    <span className="verde bold">Permanente</span>
                  ) : (
                    <input type="date" value={fechaFin} onChange={(e) => setFechaFin(e.target.value)} />
                  )}
                </div>
                <label className="checkbox mt-5">
                  <input
                    type="checkbox"
                    checked={finPermanente}
                    onChange={(e) => {
                      setFinPermanente(e.target.checked);
                      if (e.target.checked) setFechaFin("");
                    }}
                  />
                  <span className="ml-5">Permanente</span>
                </label>
              </div>

              {/* Ámbito geográfico */}
              <div className="campo column w-175">
                <label className="verde mayusculas">Ámbito geográfico *</label>
                <div className="checkbox">
                  <input
                    type="radio"
                    name="ambitoType"
                    value="Isla Cristina"
                    checked={ambitoType === "Isla Cristina"}
                    onChange={(e) => {
                      setAmbitoType(e.target.value);
                      setAmbito("Isla Cristina");
                    }}
                  />
                  <label className="ml-10">Isla Cristina</label>
                </div>
                <div className="checkbox">
                  <input
                    type="radio"
                    name="ambitoType"
                    value="Otro"
                    checked={ambitoType === "Otro"}
                    onChange={(e) => setAmbitoType(e.target.value)}
                  />
                  <label className="ml-10">Otro</label>
                </div>
                {ambitoType === "Otro" && (
                  <input type="text" value={ambito} onChange={(e) => setAmbito(e.target.value)} placeholder="Estatal, provincial..." />
                )}
              </div>
            </div>

            {/* Información */}
            <div className="campo column sobre-mi">
              <label className="verde mayusculas">INFORMACIÓN DEL RECURSO *</label>
              <textarea placeholder="Descripción..." value={descripcion} onChange={(e) => setDescripcion(e.target.value)} required />
            </div>
          </div>
        </section>

        {/* Aviso salir sin guardar */}
        {mostrarModal && (
          <div className="ventana-cancelar fondo-blanco">
            <div className="column">
              <p>
                {id ? "Si sales de esta página se perderán los cambios no guardados." : "Si sales no se guardará el recurso."} ¿Estás
                seguro?
              </p>
              <div className="botones flex gap-20">
                <button className="fondo-rojo blanco" onClick={handleSalir}>
                  Salir
                </button>
                <button className="seguir blanco fondo-verde" onClick={() => setMostrarModal(false)}>
                  {id ? "Seguir editando" : "Seguir"}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Botones Cancelar o Guardar */}
        <section className="botones flex-center">
          <button className="fondo-rojo mayusculas blanco" onClick={handleCancelar}>
            Cancelar
          </button>
          <button className="descargar mayusculas fondo-verde blanco" onClick={handleCrearRecurso}>
            {id ? "Guardar cambios" : "Crear nuevo recurso"}
          </button>
        </section>
      </main>
    </>
  );
};

export default NuevoRecursoSocial;
